export class FontsConfig {
    public static fonts = {
        Neue_Helvetica_bold: 'Neue_Helvetica_bold',
        Helvetica_Neue: 'Helvetica_Neue',
        Neue_Helvetica_light: 'Neue_Helvetica_light',
        Helvetica_Lt_Bold: 'Helvetica_Lt_Bold',
    }
}